
import { groupBy } from 'lodash';

export const formatdata = (priorityGroupedList) => {
    const groupedByCartId = groupBy(priorityGroupedList, item => item.cart_id);
    return Object.values(groupedByCartId);
};

export const groupExpoDataByMenugroup = (allOrders) => {
//    const allOrders = Object.values(expoData).reduce((mergedArr, priorityGroupedItems) => {
//         const values = Object.values(priorityGroupedItems);
//         return mergedArr.concat(values.flat());
//     }, []);
    const groupedByMenu = groupBy(allOrders, item => item.menu_item.menu_group?.menu_id ?? 'Unknown');
    return Object.values(groupedByMenu);
};
export const groupByMealCourse = (allItem) => {
    const groupedByMenu = groupBy(allItem, item => item.menu_item.meal_course_id ?? 'Unknown');
    return Object.values(groupedByMenu);
}